// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"5405b47f","453":"a8d91d34"}[chunkId] + ".chunk.js";
};